export class TableContextSegmentMapRow {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "labels",
            "baseName": "labels",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "share",
            "baseName": "share",
            "type": "number",
            "format": ""
        },
        {
            "name": "rows",
            "baseName": "rows",
            "type": "number",
            "format": ""
        },
        {
            "name": "cells",
            "baseName": "cells",
            "type": "Array<TableContextSegmentMapCell>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TableContextSegmentMapRow.attributeTypeMap;
    }
    constructor() {
    }
}
